import { ChangeEvent, useState } from "react";
import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { CompanyNameType } from "../../../../static/types/commonTypes/companyNameType";
import { LegalEntityType } from "../../../../static/types/commonTypes/legalEntityType";
import { HeadOfficeAddressType } from "../../../../static/types/commonTypes/headOfficeAddressType";
import { getCityWithPreposition } from "../../../../utils/functions/getCityWithPreposition";
import { DecisionType } from "../../../../static/types/commonTypes/decisionType";
import { ToastContainer } from "react-toastify";
import CompanyName from "../../../commonComponents/CompanyName";
import DecisionWithQuality from "../../../commonComponents/DecisionWithQuality";
import HeadOfficeAddress from "../../../commonComponents/HeadOfficeAddress";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from "react-icons/fa";
import { GoArrowRight } from "react-icons/go";
import ManagerListWithQualities from "../../../commonComponents/ManagerListWithQualities";
import { ManagerTypeWithQualite } from "../../../../static/types/commonTypes/managerType";
import LegalEntity from "../../../commonComponents/LegalEntity";
import { formatObjectText } from "../../../../utils/functions/formatObjectText";

interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const TransferOutsideDepartmentArrival: React.FC<AnnonceProps>  = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    }
) => {
    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        headOfficeAddress, setHeadOfficeAddress,
        headOfficeAddressValidity, setHeadOfficeAddressValidity,
        headOfficeAddressChecked, setHeadOfficeAddressChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        decisionWithQualityAndEffectiveDate,
        setDecisionWithQualityAndEffectiveDate,
        decisionWithQualityAndEffectiveDateValidity,
        setDecisionWithQualityAndEffectiveDateValidity,
        decisionWithQualityAndEffectiveDateChecked,
        setDecisionWithQualityAndEffectiveDateChecked,

        generalManagersWithQualite,
        setGeneralManagersWithQualite,
        generalManagersWithQualiteValidity,
        setGeneralManagersWithQualiteValidity,
        generalManagersWithQualiteChecked,
        setGeneralManagersWithQualiteChecked,
        typeGeneralManagersWithQualiteData,
        setTypeGeneralManagersWithQualiteData,

    } = useAppContext() as AppContextType
    
    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);
    const [submissive, setSubmissive] = useState<boolean>(false)
    

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });
    const updateLegalEntity = (data: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...data });
    const societyTypeOptions = Array.isArray(societyType) ? societyType : (societyType ? [societyType] : [])
    const updateHeadOfficeAddress = (data: Partial<HeadOfficeAddressType>) => setHeadOfficeAddress({ ...headOfficeAddress, ...data });
    const updateHeadOfficeAddressValidity = (isValid: boolean) => setHeadOfficeAddressValidity(isValid);
    const goToSupportPresse = () => updateActiveIndex(2);

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('raisonSociale')
        }
        else if (!decisionWithQualityAndEffectiveDateValidity) {
            setActiveTab('choisirDateDecision')
        }
        else if (!legalEntityValidity) {
            setActiveTab('laSociété')
        }
        else if (!headOfficeAddressValidity) {
            setActiveTab('nouvelleAdresseSiegeSocial')
        }
        else if (!generalManagersWithQualiteValidity) {
            setActiveTab('geranceOupResidence')
        }

        return companyNameValidity && decisionWithQualityAndEffectiveDateValidity && legalEntityValidity && headOfficeAddressValidity && generalManagersWithQualiteValidity

    };

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };
    
    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const handleSubmit = (e: ChangeEvent<HTMLFormElement>) => {

        e.preventDefault();

        console.log(validate())

        if (validate()) {

            const formatManagersList = (managers: ManagerTypeWithQualite[]) => {
                // On groupe d'abord par qualité
                const byQualite: { [key: string]: ManagerTypeWithQualite[] } = {};
                managers.forEach(manager => {
                    if (!byQualite[manager.qualite]) byQualite[manager.qualite] = [];
                    byQualite[manager.qualite].push(manager);
                });
                
                let result = '';
                Object.entries(byQualite).forEach(([qualite, managerList]) => {
                    managerList.forEach((manager) => {
                        if (manager.person === "Personne physique") {
                            result += `- ${qualite} : ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}\n`;
                        } else if(manager.person === "Personne morale") {
                            result += `- ${qualite} : ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}\n`;
                        }
                    });
                });
                return result.trim();
            };

            const pluralSubjects = ["Les associés","Les actionnaires"];

            const verb = pluralSubjects.includes(decisionWithQualityAndEffectiveDate.decisionQuality) ? "ont" : "a";
            const decisionNature = decisionWithQualityAndEffectiveDate.decisionNature === "AG Extraordinaire"
                ? "l'AGE"
                : decisionWithQualityAndEffectiveDate.decisionNature === "AG Ordinaire"
                    ? "l'AGO"
                    : decisionWithQualityAndEffectiveDate.decisionNature === "AG Mixte"
                        ? "l'AG Mixte"
                        : decisionWithQualityAndEffectiveDate.decisionNature

            const decisionText = firstPartDecision.includes(decisionWithQualityAndEffectiveDate.decisionNature)
                ? `Aux termes de ${decisionNature} en date du ${decisionWithQualityAndEffectiveDate.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionQuality} ${verb}`
                : `Le ${decisionWithQualityAndEffectiveDate.decisionDate}, ${decisionNature.toLowerCase()} ${verb}`

            const tempText = `${legalEntity.companyName}
${legalEntity.legalForm} au capital de ${legalEntity.capital} €,
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city},
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)},
${decisionText} décidé de transférer le siège social ${headOfficeAddress.address} ${headOfficeAddress.additionalAddress} ${headOfficeAddress.postalCode}  ${headOfficeAddress.city}, à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}.
${formatManagersList(generalManagersWithQualite)},
Radiation au RCS  ${getCityWithPreposition(legalEntity.registrationOffice)} et réimmatriculation au RCS ${getCityWithPreposition(headOfficeAddress.registrationOffice)}.
`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
            setSubmissive(true)
        }

        else setSubmissive(false)
    };

    const handleNext = () => {
        if (activeTab === "raisonSociale") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("raisonSociale"));
            }
        } else if (activeTab === "choisirDateDecision") {
            setDecisionWithQualityAndEffectiveDateChecked(true)
            if (decisionWithQualityAndEffectiveDateValidity) {
                switchTab(getNextTab("choisirDateDecision"));
            }
        } else if (activeTab === "laSociété") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("laSociété"));
            }
        } else if (activeTab === "nouvelleAdresseSiegeSocial") {
            setHeadOfficeAddressChecked(true)
            if (headOfficeAddressValidity) {
                switchTab(getNextTab("nouvelleAdresseSiegeSocial"));
            }
        }
        else if (activeTab === "geranceOupResidence") {
            setGeneralManagersWithQualiteChecked(true)
            if (generalManagersWithQualiteValidity) {
                setSubmissive(true);
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQualityAndEffectiveDate({ ...decisionWithQualityAndEffectiveDate, ...data });

    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'raisonSociale':
                return 'choisirDateDecision';
            case 'choisirDateDecision':
                return 'laSociété';
            case 'laSociété':
                return 'nouvelleAdresseSiegeSocial';
            case 'nouvelleAdresseSiegeSocial':
                return 'geranceOupResidence';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'geranceOupResidence': 
                return 'nouvelleAdresseSiegeSocial'
            case 'nouvelleAdresseSiegeSocial':
                return 'laSociété';
            case 'laSociété':
                return 'choisirDateDecision';
            case 'choisirDateDecision':
                return 'raisonSociale';
            default:
                return currentTab;
        }
    };

    console.log(societyTypeOptions);

    const tabs =[
        {key: 'raisonSociale', label: 'Raison Sociale'},
        {key: 'choisirDateDecision', label: "Choisir l'organe et la date de la décision"},
        {key: 'laSociété', label: 'La société'},
        {key: 'nouvelleAdresseSiegeSocial', label: 'Nouvelle adresse du siège social'},
        {key: 'geranceOupResidence', label: 'La Gérance / Présidence (Représentant légal)'},
    ]
    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'raisonSociale' &&
                    <div>
                        <span>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                companyName={companyName}
                                checked={companyNameChecked}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                            <h6 className = 'text-bold' style={{backgroundColor: 'red', padding: '5px', color: 'white', fontSize: '13px'}}>
                                IMPORTANT : Dans le cas d'un transfert de siège hors département, ce formulaire génère l'annonce d'arrivée, vous devez également publier l'annonce de départ.
                            </h6>
                        </div>
                    </div>

                }

                {
                    activeTab === 'choisirDateDecision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQualityAndEffectiveDate}
                        draftFieldName = 'decisionWithQualityAndEffectiveDate'
                        checked={decisionWithQualityAndEffectiveDateChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityAndEffectiveDateValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'laSociété' &&
                    <div>
                        <span>
                            Pour la société, veuillez préciser l'adresse du siège social
                        </span>
                        <div className="tab-content">
                        <LegalEntity
                                companyName={companyName}
                                setCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                                checked={legalEntityChecked}
                                legalEntity={legalEntity}
                                changeLegalEntity={updateLegalEntity}
                                societyType={societyTypeOptions}
                                onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                                draftFieldName = 'legalEntity'
                            />
                        </div>
                    </div>

                }

                {
                    activeTab === "nouvelleAdresseSiegeSocial" &&
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={updateHeadOfficeAddress}
                        checked={headOfficeAddressChecked}
                        headOfficeAddress={headOfficeAddress}
                        onValidationChange={updateHeadOfficeAddressValidity}
                    />
                }

                {
                    activeTab === "geranceOupResidence" &&
                    <ManagerListWithQualities
                        addButtonText='Ajouter un dirigeant'
                        removeButtonText='Supprimer le dernier dirigeant'
                        checked={generalManagersWithQualiteChecked}
                        managers={generalManagersWithQualite}
                        qualitiesOptions={[
                            "Gérant",
                            "Co-gérant",
                            "Président",
                            "Directeur Général",
                            "Directeur Général Délégué",
                            "Président du conseil d'administration ",
                            "Président du conseil d'admin. et Directeur Général"
                        ]}
                        setManagers={setGeneralManagersWithQualite}
                        setManagersValidity={setGeneralManagersWithQualiteValidity}
                        societyTypeOptions={societyTypeOptions}
                    />
                }

                {
                    activeTab === "geranceOupResidence" &&
                    submissive &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== "raisonSociale" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }
                        {
                            activeTab === "geranceOupResidence" &&
                            <button type="submit"
                                onClick={handleNext}>
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }
                        {
                            activeTab !== "geranceOupResidence" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}>
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive &&
                            activeTab === "geranceOupResidence" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }
                    </div>
                </div>
            </form>
        </>
    );
};

export default TransferOutsideDepartmentArrival